// import { CartesianGrid, Line, LineChart, Tooltip, XAxis } from 'recharts';
import AdminHeader from '../../components/adminHeader/adminHeader';
import BannerImage from '../../components/bannerImage/bannerImage';
import './adminAnalytics.css';
import React, { use, useEffect, useRef, useState } from 'react';
import connector from '../../connector/connector';
import AssessmentsLineChart from '../../components/lineChart/lineChart';
import { useNavigate } from 'react-router-dom';
import { normalizeChartData } from '../../utils/transformData';
import {
    LineChart,
    BarChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
    CartesianGrid,
    LabelList,
} from "recharts";
import utilities from '../../utils/utils';
import moment, { max } from 'moment';
import Footer from '../../components/footer/footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faFileExport } from '@fortawesome/free-solid-svg-icons';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import config from '../../config/config';
import { filter, lab } from 'd3';


const formatDate = date =>
    date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
    });

const METRICS = [
    "Strategic Alignment",
    "Earning & Maintaining Trust",
    "Data & Infrastructure Readiness",
    "External & Internal Stakeholders",
    "Governance & Oversight",
    "Procurement & Policy Enablement",
    "Skills & Capacity",
    "Technology Infrastructure",
    'Use Case Selection & Scaling',
    'AI Scaling Roadmap'
];

const COLORS = [
    "#2563eb",
    "#dc2626",
    "#16a34a",
    "#9333ea",
    "#ea580c",
    "#0891b2",
    "#65a30d",
    "#6b7280"
];
const labelFontSize = 23;







const groupByMonthWithRange = (assessments) => {
    if (!assessments.length) return [];
  
    const monthlyCounts = {};
  
    // 1. Count assessments per month
    assessments.forEach(({ createdTime }) => {
      const monthStart = moment(createdTime).startOf("month");
      const key = monthStart.format("YYYY-MM-DD");
  
      monthlyCounts[key] = (monthlyCounts[key] || 0) + 1;
    });
  
    // 2. Determine full date range
    const minMonth = moment.min(
      assessments.map(a => moment(a.createdTime).startOf("month"))
    );
  
    const maxMonth = moment.max(
      assessments.map(a => moment(a.createdTime).startOf("month"))
    );
  
    // 3. Walk month-by-month and fill gaps
    const results = [];
    let currentMonth = minMonth.clone();
  
    while (currentMonth.isSameOrBefore(maxMonth)) {
      const key = currentMonth.format("YYYY-MM-DD");
      const monthEnd = currentMonth.clone().endOf("month");
  
      results.push({
        monthRange: `${currentMonth.format("MMM YYYY")}`,
        count: monthlyCounts[key] || 0,
      });
  
      currentMonth.add(1, "month");
    }
  
    return results;
  };
  









const AdminAnalytics = () => {

    const navigate = useNavigate();


    const pdfRef = useRef();


    const [gradebookDisplayList, setGradebookDisplayList] = useState([]);
    const [allGradeData, setAllGradeData] = useState([]);
    const [dataCopy, setDataCopy] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [noShowText, setNoShowText] = useState('');
    const [catMaxes, setCatMaxes] = useState([
        { maxPoints: 0 },
        { maxPoints: 0 },
        { maxPoints: 0 },
    ]);
    const [totalMax, setTotalMax] = useState(0);
    const [browserData, setBrowserData] = useState([]);
    const [deviceData, setDeviceData] = useState([]);
    const [questionsSelect, setQuestionsSelect] = useState([]);
    const [rawQuestionChartData, setRawQuestionChartData] = useState({});
    const [questionIsMultiSelect, setQuestionIsMultiSelect] = useState(false);
    const [averageCompletionTime, setAverageCompletionTime] = useState('');
    const [timeFrame, setTimeFrame] = useState('');
    const [printQuestionSelect, setPrintQuestionSelect] = useState(false);
    const [showExportButton, setShowExportButton] = useState(false);
    // const [allGradeData, setAllGradeData] = useState([]);
    const [filteredGradeData, setFilteredGradeData] = useState([]);
    const [qualifiedAssesmentCount, setQualifiedAssesmentCount] = useState([
        {
            name: 'Qualified Assessments', value: 0,
        }, {
            name: 'Email Provided', value: 0,
        }, {
            name: 'Counted', value: 0,
        }
    ]);
    const [showExpandedInfo, setShowExpandedInfo] = useState(false);
    const [showAllTotalScore, setShowAllTotalScore] = useState(true);
    const [showCaicTotalScore, setShowCaicTotalScore] = useState(false);
    const [topicsChartData, setTopicsChartData] = useState([]);
    const [topicsMaxes, setTopicsMaxes] = useState({});
    const [showTopicLegend, setShowTopicLegend] = useState(false);


    function buildTopicAverages(data) {
        const totals = {};
        const counts = {};

        METRICS.forEach(topic => {
            totals[topic] = 0;
            counts[topic] = 0;
        });

        data.forEach(record => {
            const fields = record.fields;

            METRICS.forEach(topic => {
                const value = fields[topic];
                if (typeof value === "number") {
                    totals[topic] += value;
                    counts[topic] += 1;
                }
            });
        });

        console.log('topicsMaxes', topicsMaxes);

        return METRICS.map(topic => ({
            topic,
            averageScore:
                Math.round(
                    ((totals[topic] / counts[topic]) / topicsMaxes[topic]) * 100
                )
            // Store as a decimal for percentage formatting later

        })).sort((a, b) => b.averageScore - a.averageScore);
    }




    const handleDownload = async () => {
        try {

            const input = pdfRef.current;

            if (!input) {
                console.error('PDF reference element not found');
                return;
            }

            // Wait a bit for any dynamic content to load
            await new Promise(resolve => setTimeout(resolve, 500));

            const canvas = await html2canvas(input, {
                scale: 4,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                // foreignObjectRendering: true,
                onclone: (clonedDoc) => {
                    // Remove any gradients before rendering
                    clonedDoc.querySelectorAll('*').forEach(el => {
                        const bg = window.getComputedStyle(el).backgroundImage;
                        if (bg && bg.includes('gradient')) {
                            el.style.backgroundImage = 'none';
                            el.style.backgroundColor = '#fff'; // or a neutral fallback
                        }
                        // Also strip out SVG gradients if they exist
                        if (el.tagName === 'svg') {
                            el.querySelectorAll('linearGradient, radialGradient').forEach(g => g.remove());
                        }
                        if (el.classList && el.classList.contains('no-print')) {
                            el.style.display = 'none';
                        }
                    });
                }
            });

            // Verify canvas was created successfully
            if (!canvas || canvas.width === 0 || canvas.height === 0) {
                throw new Error('Failed to create canvas from element');
            }

            // Get the canvas data as data URL directly
            const imgData = canvas.toDataURL('image/png', 1.0);

            // Verify the data URL format
            if (!imgData.startsWith('data:image/png;base64,')) {
                throw new Error('Invalid image data format');
            }

            const pdf = new jsPDF('p', 'pt', 'a4');

            pdf.setProperties({
                title: `GovEx ${config.applicationName} Analytics Report`,
                subject: `GovEx ${config.applicationName} Analytics Report`,
                author: 'Bloomberg Center for Government Excellence aat Johns Hopkins University',
                keywords: 'GovEx, Analytics, Report, AI Capacity Quiz',
                creator: 'GovEx Analytics Module',
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            // Calculate dimensions to fit entire content on one page
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;

            // If the image is taller than the page, scale it down to fit
            if (imgHeight > pdfHeight) {
                const scaleFactor = pdfHeight / imgHeight;
                const scaledWidth = imgWidth * scaleFactor;
                const scaledHeight = pdfHeight;

                // Center the image horizontally if it's scaled down
                const xOffset = (pdfWidth - scaledWidth) / 2;

                pdf.addImage(imgData, 'PNG', xOffset, 0, scaledWidth, scaledHeight);
            } else {
                // Center the image vertically if it's shorter than the page
                const yOffset = (pdfHeight - imgHeight) / 2;
                pdf.addImage(imgData, 'PNG', 0, yOffset, imgWidth, imgHeight);
            }

            pdf.save(`GovEx ${config.applicationName} Analytics Report ${timeFrame}.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('There was an error generating the PDF. Please try again.');
        }
    };


    if (!localStorage.getItem('adminTokenTime') || utilities.isdateOlderThan30Minutes(localStorage.getItem('adminTokenTime'))) {
        navigate('/admin');
    }

    const getMetricSummary = (metric) => {
        // console.log('something', topicsChartData.filter(entry => entry.fields['Weighted'] === 'true'));
        const total = topicsChartData.reduce(
            (acc, entry) => acc + (Number(entry.fields[metric]) || 0),
            0


        );
        console.log('total', total)
        const avg = topicsChartData.length ? total / chartData.length : 0;
        const max = topicsMaxes[metric] || 0;

        console.log('metric', metric, 'avg', avg, 'max', max);

        return `${metric}: ${utilities.calculatePercentage(avg, max)}% (${avg.toFixed(
            0
        )} out of ${max} points)`;
    };


    useEffect(() => {

        const fetchGradebookData = async () => {
            // get gradebook data
            let allGradeData = await connector.fetchGradebookData();
            setAllGradeData(allGradeData);
            let gradeData = allGradeData.filter(entry => entry.fields['Weighted'] === 'true');
            console.log('gradeData', gradeData);
            const sortedGradeData = [...gradeData].sort(
                (a, b) => new Date(b.createdTime) - new Date(a.createdTime)
            );

            setGradebookDisplayList(sortedGradeData);
            setDataCopy(sortedGradeData);

            setChartData(normalizeChartData(gradeData.filter(entry => entry.fields['Weighted'] === 'true')));
            setGradebookDisplayList(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)));
            setDataCopy(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)));
            setBrowserData(normalizeBrowserData(gradeData));
            setDeviceData(normalizeDeviceData(gradeData));
            setFilteredGradeData(allGradeData);
            console.log('allGradeData', allGradeData);
            setQualifiedAssesmentCount([{
                name: 'Qualified Assessments', value: allGradeData.filter(entry => entry.fields['responses'].length > 32).length
            },
            { name: 'Identified assessments via email', value: allGradeData.filter(entry => entry.fields['responses'].length > 32 && entry.fields['Submitted By']).length },
            { name: 'Assessments included in benchmark average', value: allGradeData.filter(entry => entry.fields['responses'].length > 32 && entry.fields['Submitted By'] && entry.fields['Weighted'] === 'true').length }]
            );
            setTopicsChartData(gradeData);



            console.table('qualifiedAssesmentCount', qualifiedAssesmentCount);

            // let qualifiedAssessments  = gradeData.filter(entry => entry.fields['Responses'].length > 32);
            let millis = [];
            for (let i = 0; i < gradeData.length; i++) {
                if (gradeData[i].fields['Total Duration (ms)']) {
                    millis.push(gradeData[i].fields['Total Duration (ms)']);
                }
            }

            setAverageCompletionTime(millis.reduce((acc, val) => acc + val, 0) / millis.length);

            // console.log('gradeData', gradeData);

            let maximums = await connector.getCategoryMaximums();
            // console.log('maximums', maximums.length, maximums);
            setCatMaxes(maximums);
            // console.log('maximums', maximums);
            let tempTotalMax = 0;
            for (let key in maximums) {
                tempTotalMax += parseInt(maximums[key].maxPoints);

            }
            setTotalMax(tempTotalMax);
            // console.log('totalMax', totalMax);


            let fetchedTopicMaxes = await connector.getTopicMaximums();
            setTopicsMaxes(fetchedTopicMaxes);
            setShowTopicLegend(true);
            setShowExportButton(true);
        };

        fetchGradebookData();

    }, []);


    useEffect(() => {
        const fetchQuestions = async () => {
            const fetchedQuestions = await connector.getQuestions('Policy');
            // console.log("fetchedQuestions", fetchedQuestions);
        };

        fetchQuestions();
    }, []);

    const goToAssessment = (id) => {
        navigate(`/admin/gradebook/assessment/${id}`)
    }

    function CustomTooltip({ active, payload, label }) {
        if (!active || !payload || !payload.length) return null;

        const data = payload[0].payload;

        return (
            <div
                style={{
                    background: "#ffffff",
                    border: "1px solid #e5e7eb",
                    padding: "8px 12px",
                    borderRadius: 6,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                }}
            >
                <div style={{ fontSize: 12, color: "#6b7280" }}>
                    {new Date(label).toLocaleString()}
                </div>

                <div style={{ fontWeight: 600, marginTop: 4 }}>
                    Total Score: {data.totalScore}
                </div>

                <div style={{ fontSize: 12, marginTop: 4 }}>
                    Submitted by: {data.submittedBy}
                </div>
            </div>
        );
    }

    function normalizeBrowserData(data) {
        const counts = {};

        data.forEach(item => {
            const browser = item.fields.Browser || "Unknown";
            counts[browser] = (counts[browser] || 0) + 1;
        });

        return Object.entries(counts).map(([browser, count]) => ({
            browser,
            count,
        }));
    }

    function normalizeDeviceData(data) {
        const counts = {};

        data.forEach(item => {
            const device = item.fields['Device Type'] || "Unknown";
            counts[device] = (counts[device] || 0) + 1;
        });

        return Object.entries(counts).map(([device, count]) => ({
            device,
            count,
        }));
    }

    const transformData = (records) => {
        return records
            .map(r => ({
                date: r.createdTime,
                ...METRICS.reduce((acc, key) => {
                    acc[key] = r.fields[key] ?? 0;
                    return acc;
                }, {})
            }))
            .sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const questionChartData = Object.entries(rawQuestionChartData).map(([name, value]) => ({
        name,
        value
    }));

    const handleInfoToggle = () => {
        setShowExpandedInfo(!showExpandedInfo);
    }

    function handleDateFilter(e) {
        let filterValue = e.target.value;
        // console.log('filterValue', filterValue);
        let now = new Date();

        let filteredData = dataCopy.filter(entry => {
            let entryDate = new Date(entry.createdTime);

            let timeDiff = now - entryDate;
            // console.log('timeDiff', timeDiff);
            let daysDiff = timeDiff / (1000 * 3600 * 24);
            // console.log('daysDiff', daysDiff);
            switch (filterValue) {
                case 'Past Year':
                    setTimeFrame(' in the past year');
                    return daysDiff <= 365;
                case 'Past 6 Months':
                    setTimeFrame(' in the past 6 months');
                    return daysDiff <= 182;
                case 'Past 3 Months':
                    setTimeFrame(' in the past 3 months');
                    return daysDiff <= 90;
                case 'Past Month':
                    setTimeFrame(' in the past month');
                    return daysDiff <= 30;
                case 'Past Week':
                    setTimeFrame(' in the past week');
                    return daysDiff <= 7;
                default:
                    setTimeFrame('');
                    return true; // 'All Submissions'
            }
        });

        let allFilteredData = allGradeData.filter(entry => {
            let entryDate = new Date(entry.fields['Created At']);

            let timeDiff = now - entryDate;
            // console.log('timeDiff', timeDiff);
            let daysDiff = timeDiff / (1000 * 3600 * 24);
            // console.log('daysDiff', daysDiff);
            switch (filterValue) {
                case 'Past Year':
                    return daysDiff <= 365;
                case 'Past 6 Months':
                    return daysDiff <= 182;
                case 'Past 3 Months':
                    return daysDiff <= 90;
                case 'Past Month':
                    return daysDiff <= 30;
                case 'Past Week':
                    return daysDiff <= 7;
                default:
                    return true; // 'All Submissions'
            }
        });
        // console.log("all grade data", allGradeData)
        // console.log('filteredData', filteredData);
        // console.log('allFilteredData', allFilteredData);
        setGradebookDisplayList(filteredData);
        setChartData(normalizeChartData(filteredData.filter(entry => entry.fields['Weighted'] === 'true')));
        setBrowserData(normalizeBrowserData(filteredData));
        setDeviceData(normalizeDeviceData(filteredData));
        setFilteredGradeData(allFilteredData);
        setQualifiedAssesmentCount([{
            name: 'Qualified Assessments', value: allFilteredData.filter(entry => entry.fields['responses'].length > 32).length
        },
        { name: 'Email Provided', value: allFilteredData.filter(entry => entry.fields['responses'].length > 32 && entry.fields['Submitted By']).length },
        { name: 'Counted', value: allFilteredData.filter(entry => entry.fields['responses'].length > 32 && entry.fields['Submitted By'] && entry.fields['Weighted'] === 'true').length }]
        );
        setAverageCompletionTime(() => {
            let millis = [];
            for (let i = 0; i < filteredData.length; i++) {
                if (filteredData[i].fields['Total Duration (ms)']) {
                    millis.push(filteredData[i].fields['Total Duration (ms)']);
                }
            }
            return millis.reduce((acc, val) => acc + val, 0) / millis.length;
        });




    }

    const handleQuestionSelect = async (e) => {
        let selectedValue = e.target.value;
        let selectedQuestions = await connector.getQuestions(selectedValue);
        setQuestionsSelect(selectedQuestions);
        if (e.target.value == 'Select a Category') {
            // console.log('setting print to false');
            setPrintQuestionSelect(false);
        }
        else {
            // console.log('setting print to true');
            setPrintQuestionSelect(true);
        }
        // console.log('selectedQuestions', selectedQuestions);
    }

    const handleQuestionChange = async (questionId) => {
        if (!questionId || questionId === 'Select a Question') {
            return;
        }
        // console.log('questionId', questionId);
        let singleQuestionData = await connector.getQuestionById(questionId);
        // console.log('singleQuestionData', singleQuestionData);

        // console.log('questionIsMultiSelect', singleQuestionData.fields['Multi-Select']);
        let questionData = await connector.getResponsesByQuestionId(questionId, true);
        setRawQuestionChartData(questionData);
        setQuestionIsMultiSelect(singleQuestionData.fields['Multi-select'] === 'true' ? true : false);
    }

    function filterByCaicPartners() {
        let filteredData = dataCopy.filter(entry => entry.fields['CAIC'] === true);
        setGradebookDisplayList(filteredData);
        setChartData(normalizeChartData(filteredData.filter(entry => entry.fields['Weighted'] === 'true')));
        setBrowserData(normalizeBrowserData(filteredData));
        setDeviceData(normalizeDeviceData(filteredData));
        setShowAllTotalScore(false);
        setShowCaicTotalScore(true);
        setFilteredGradeData(allGradeData.filter(entry => entry.fields['CAIC'] === true));
        setTimeFrame('')
    }

    function filterByAll() {
        setGradebookDisplayList(dataCopy);
        setChartData(normalizeChartData(dataCopy.filter(entry => entry.fields['Weighted'] === 'true')));
        setBrowserData(normalizeBrowserData(dataCopy));
        setDeviceData(normalizeDeviceData(dataCopy));
        setShowAllTotalScore(true);
        setShowCaicTotalScore(false);
        setFilteredGradeData(allGradeData);
    }

    return (
        <div className='admin-analytics-page' ref={pdfRef}>
            <div className='no-print'>
                <AdminHeader></AdminHeader>
            </div>
            <BannerImage text={`Analytics ${timeFrame != '' ? `(assessments submitted ${timeFrame})` : ''}`}></BannerImage>

            <div className='filter-menu-wrapper no-print'>
                <select onChange={handleDateFilter} className='filter-menu'>
                    <option value="all">All Submissions</option>
                    <option>Past Year</option>
                    <option>Past 6 Months</option>
                    <option>Past 3 Months</option>
                    <option value='Past Month'>Past Month</option>
                    <option value='Past Week'>Past Week</option>
                </select>

                <button onClick={filterByAll} className={showAllTotalScore ? 'btn-selected' : 'btn-unselected'}>All</button> <button onClick={filterByCaicPartners} className={showCaicTotalScore ? 'btn-selected' : 'btn-unselected'}>CAIC Partners</button>
                <p className='analytics-export-btn' onClick={handleDownload} style={{ visibility: `${showExportButton ? 'visible' : 'hidden'}` }}><FontAwesomeIcon icon={faFileExport}></FontAwesomeIcon></p>
            </div>

            <div className='gradebook-disclaimer'><p>{`Of the ${filteredGradeData.length} assessments that were submitted${timeFrame}, ${gradebookDisplayList.length} (${utilities.calculatePercentage(gradebookDisplayList.length, filteredGradeData.length)}%) of them ${gradebookDisplayList.length === 1 ? 'has' : 'have'} been verified and ${gradebookDisplayList.length === 1 ? 'is' : 'are'} included in the following analytics report`}</p></div>

            <h2 style={{ color: '#a15a95' }}>Submissions:</h2>

            {/* <p>moment.utc(avgMs).format("HH:mm:ss");</p> */}

            {showAllTotalScore && <p className='avg-time-p' style={{ color: '#a15a95' }}>Average time to complete survey:<span>{moment.utc(averageCompletionTime).format("HH:mm:ss")}</span></p>}

            <div className="submission-list-wrapper">
                <ol className="submission-list">
                    {gradebookDisplayList
                        .filter(entry => entry.fields['Weighted'] === 'true')
                        .reverse()
                        .map((entry, idx) => (
                            <li
                                key={entry.id}
                                className="submission-list-item"
                                onClick={() => goToAssessment(entry.fields.Assessment)}
                            >
                                <span className="submission-list-item-date">
                                    {`${idx + 1}. ${entry.fields['CAIC']
                                        ? 'City AI Connect Partner'
                                        : `${entry.fields['City']}, ${entry.fields['State/Territory']} (${entry.fields['Country Code']})`
                                        } | ${new Date(entry.createdTime).toLocaleDateString()}`}
                                </span>
                            </li>
                        ))}
                </ol>
            </div>
            <div className='data-viz-wrapper'>

                <h2 style={{ color: '#0A90F0' }}>Assessments taken Monthly</h2>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={groupByMonthWithRange(gradebookDisplayList)}>
                        <XAxis
                            dataKey="monthRange"
                            angle={-20}
                            textAnchor="end"
                            height={70}
                            tick={{ fontSize: labelFontSize }}

                        />
                        <YAxis allowDecimals={false} tick={{ fontSize: labelFontSize }} />
                        <Tooltip
                            formatter={(value) => [`${value} assessments`, "Count"]}
                        />
                        <Bar dataKey="count" fill='#0A90F0' />
                    </BarChart>
                </ResponsiveContainer>


                <h2 style={{ color: '#3182bd' }}>{`Assessments taken by total score ${showCaicTotalScore ? '(City AI Connect Partners)' : ''}`}</h2>

                <div>
                    {showExportButton && <ul>
                        <li className='viz-legend' style={{ color: '#3182bd' }}>Total Average Score:</li>
                        <li style={{ backgroundColor: '#3182bd' }} >{
                            `${utilities.calculatePercentage(chartData.reduce((acc, entry) => acc + entry.total, 0) / chartData.length, totalMax)}% (${(chartData.reduce((acc, entry) => acc + entry.total, 0) / chartData.length).toFixed(0)} out of ${totalMax} points)`
                        }</li>
                    </ul>}
                </div>

                <ResponsiveContainer width="100%" height={500}>
                    <LineChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="date"
                            type="number"
                            scale="time"
                            domain={["dataMin", "dataMax"]}
                            tickFormatter={formatDate}
                            tick={{ fontSize: labelFontSize }}
                        />
                        <YAxis tick={{ fontSize: labelFontSize }} />

                        <Tooltip content={<CustomTooltip />} />
                        <Line
                            type="monotone"
                            dataKey="total"
                            stroke='#3182bd'
                            strokeWidth={3}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
                <h2 style={{ color: '#9333ea' }}>{`Assessments taken by category ${showCaicTotalScore ? '(City AI Connect Partners)' : ''}`}</h2>
                {showExportButton && <ul>
                    <li style={{ color: '#9333ea' }}>Total Averages by Category:</li>
                    <li className='viz-legend' style={{ backgroundColor: '#2563eb' }}>Policy: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.policy, 0) / chartData.length).toFixed(2), catMaxes[1].maxPoints)}% (${(chartData.reduce((acc, entry) => acc + entry.policy, 0) / chartData.length).toFixed(0)} out of ${catMaxes[1].maxPoints} points)`}</li>
                    <li className='viz-legend' style={{ backgroundColor: '#16a34a' }}>People: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.people, 0) / chartData.length).toFixed(2), catMaxes[0].maxPoints)}% (${(chartData.reduce((acc, entry) => acc + entry.people, 0) / chartData.length).toFixed(0)} out of ${catMaxes[0].maxPoints} points)`}</li>
                    <li className='viz-legend' style={{ backgroundColor: '#9333ea' }}>Technology: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.technology, 0) / chartData.length).toFixed(2), catMaxes[2].maxPoints)}% (${(chartData.reduce((acc, entry) => acc + entry.technology, 0) / chartData.length).toFixed(0)} out of ${catMaxes[2].maxPoints} points)`}</li>
                </ul>
                }
                <ResponsiveContainer width="100%" height={500}>
                    <LineChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />

                        <XAxis
                            dataKey="date"
                            tickFormatter={formatDate}
                            type="number"
                            domain={["dataMin", "dataMax"]}
                            scale="time"
                            tick={{ fontSize: labelFontSize }}
                        />

                        <YAxis tick={{ fontSize: labelFontSize }} />

                        <Tooltip
                            labelFormatter={value =>
                                new Date(value).toLocaleString()
                            }
                        />

                        <Line
                            type="monotone"
                            dataKey="policy"
                            stroke="#2563eb"
                            strokeWidth={2}
                            dot={true}
                        />

                        <Line
                            type="monotone"
                            dataKey="people"
                            stroke="#16a34a"
                            strokeWidth={2}
                            dot={true}
                        />

                        <Line
                            type="monotone"
                            dataKey="technology"
                            stroke="#9333ea"
                            strokeWidth={2}
                            dot={true}
                        />
                    </LineChart>
                </ResponsiveContainer>

                <h2 style={{ color: '#4f46e5' }}>Topic averages (bar chart)</h2>

                <ResponsiveContainer width="100%" height={700}>
                    <BarChart
                        data={buildTopicAverages(gradebookDisplayList)}
                        layout="vertical"
                        margin={{ top: 20, right: 30, left: 80, bottom: 20 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />

                        <XAxis
                            type="number"
                            tick={{ fontSize: labelFontSize }}
                            label={{ value: "Average Score", position: "insideBottom", offset: -10 }}
                        />

                        <YAxis
                            type="category"
                            dataKey="topic"
                            tick={{ fontSize: labelFontSize }}
                            width={220}
                        />

                        <Tooltip />

                        <Bar
                            dataKey="averageScore"
                            fill="#4f46e5"
                            radius={[0, 6, 6, 0]}
                            height={30}
                        >
                            <LabelList
                                dataKey="averageScore"
                                position="right"
                                style={{ fontSize: labelFontSize, fill: "#111" }}
                                formatter={(value) => `${value}%`}
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>

                <h2 style={{ color: '#25E669' }}>Assessments by topic score</h2>
                {/* {console.log(chartData)} */}
                {
                    showTopicLegend && <ul>
                        {METRICS.map((metric, i) => (
                            <li key={metric} className='viz-legend' style={{ backgroundColor: COLORS[i % COLORS.length] }}>
                                {getMetricSummary(metric)}
                            </li>
                        ))}
                    </ul>
                }

                <ResponsiveContainer width="100%" height={800}>
                    <LineChart data={transformData(gradebookDisplayList)}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: labelFontSize }}
                            tickFormatter={(v) =>
                                new Date(v).toLocaleDateString()
                            }
                        />
                        <YAxis tick={{ fontSize: labelFontSize }} />
                        <Tooltip
                            labelFormatter={(v) =>
                                new Date(v).toLocaleString()
                            }
                        />
                        {/* <Legend /> */}

                        {METRICS.map((metric, i) => (
                            <Line
                                key={metric}
                                type="monotone"
                                dataKey={metric}
                                stroke={COLORS[i % COLORS.length]}
                                strokeWidth={2}
                                dot={false}
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>


                {/* <h2>Assessments taken by Topic</h2>

                <ul>
                    <li style={{ color: 'black' }}>Total Averages by Category:</li>
                    <li className='viz-legend' style={{ backgroundColor: '#2563eb' }}>Policy: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.policy, 0) / chartData.length).toFixed(2), catMaxes[1].maxPoints)}%`}</li>
                    <li className='viz-legend' style={{ backgroundColor: '#16a34a' }}>People: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.policy, 0) / chartData.length).toFixed(2), catMaxes[0].maxPoints)}%`}</li>
                    <li className='viz-legend' style={{ backgroundColor: '#9333ea' }}>Technology: {`${utilities.calculatePercentage((chartData.reduce((acc, entry) => acc + entry.policy, 0) / chartData.length).toFixed(2), catMaxes[2].maxPoints)}%`}</li>
                </ul>

                <ResponsiveContainer width="100%" height={500}>
                    <LineChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />

                        <XAxis
                            dataKey="date"
                            tickFormatter={formatDate}
                            type="number"
                            domain={["dataMin", "dataMax"]}
                            scale="time"
                        />

                        <YAxis />

                        <Tooltip
                            labelFormatter={value =>
                                new Date(value).toLocaleString()
                            }
                        />

                        <Line
                            type="monotone"
                            dataKey="policy"
                            stroke="#2563eb"
                            strokeWidth={2}
                            dot={true}
                        />

                        <Line
                            type="monotone"
                            dataKey="people"
                            stroke="#16a34a"
                            strokeWidth={2}
                            dot={true}
                        />

                        <Line
                            type="monotone"
                            dataKey="technology"
                            stroke="#9333ea"
                            strokeWidth={2}
                            dot={true}
                        />
                    </LineChart>
                </ResponsiveContainer> */}

                <h2 style={{ color: '#2563eb' }}>{`Assessments by browser ${showCaicTotalScore ? '(City AI Connect Partners)' : ''}`}</h2>

                <ResponsiveContainer width="100%" height={500}>
                    <BarChart data={browserData} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="browser" tick={{ fontSize: labelFontSize }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: labelFontSize }} />
                        <Tooltip />
                        <Bar dataKey="count" fill='#2563eb' />
                    </BarChart>
                </ResponsiveContainer>


                <h2 style={{ color: '#32EA8B' }}>{`Assessments taken by device type${showCaicTotalScore ? '(City AI Connect Partners)' : ''}`}</h2>

                <ResponsiveContainer width="100%" height={500}>
                    <BarChart data={deviceData} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="device" tick={{ fontSize: labelFontSize }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: labelFontSize }} />
                        <Tooltip />
                        <Bar dataKey="count" fill='#32EA8B' />
                    </BarChart>
                </ResponsiveContainer>

                <h2 style={{ color: '#8884d8' }}>Qualified Assessments Overview <span onClick={handleInfoToggle} className='no-print'><FontAwesomeIcon icon={faCircleInfo}></FontAwesomeIcon></span></h2>
                <div className='qualified-info-box no-print' style={{ display: `${showExpandedInfo ? 'block' : 'none'}` }}>
                    <p><strong>Qualified Assessments:</strong> Assessments with all questions answered.</p>
                    <p><strong>Email Provided:</strong> Qualified assessments where the user provided an email address.</p>
                    <p><strong>Counted:</strong> Qualified assessments where the user provided a verified email address and the assessment is marked as counted.</p>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={qualifiedAssesmentCount} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" tick={{ fontSize: labelFontSize }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: labelFontSize }} />
                        <Tooltip />
                        <Bar dataKey="value" fill="#8884d8" />
                    </BarChart>
                </ResponsiveContainer>
                <div className={printQuestionSelect ? 'question-response-wrapper' : 'no-print'} style={{ marginBottom: '80px' }}>
                    <h2 style={{ color: '#EB986C' }}>Question Response Distribution</h2>

                    <div className='question-select-wrapper'>
                        <select onChange={(e) => { handleQuestionSelect(e); }} style={{ color: '#EB986C' }} >
                            <option>Select a Category</option>
                            <option value='Policy'>Policy</option>
                            <option value='People'>People</option>
                            <option value='Technology'>Technology</option>
                            <option value='Opportunities'>Opportunities</option>
                        </select>

                        <select onChange={(e) => { handleQuestionChange(e.target.value); }} style={{ color: '#EB986C' }}>
                            <option >Select a Question</option>
                            {questionsSelect.map((question, idx) => (
                                <option key={idx} value={question.id}>{question.question}</option>
                            ))}
                        </select>
                        {questionIsMultiSelect && <p className='multi-select-note'>Multiple Choice</p>}
                    </div>



                    <ResponsiveContainer width="100%" height={500}>
                        <BarChart
                            data={questionChartData}
                            margin={{ top: 20, right: 20, left: 0, bottom: 60 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="name"
                                angle={-3}
                                textAnchor="end"
                                interval={0}
                                tick={{ fontSize: 20 }}
                            />
                            <YAxis allowDecimals={false} tick={{ fontSize: labelFontSize }} />
                            <Tooltip />
                            <Bar dataKey="value" fill="#EB986C" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>





            <Footer></Footer>

        </div>
    );
};

export default AdminAnalytics;